import { render, staticRenderFns } from "./formelement_textpicker_edit.vue?vue&type=template&id=3afbd4c2&"
import script from "./formelement_textpicker_edit.vue?vue&type=script&lang=js&"
export * from "./formelement_textpicker_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports